import * as React from 'react';
import styled from 'styled-components';
import { navItems } from '../left/Tools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme';
import { NavLink } from 'react-router-dom';

const Wrapper = styled.nav`
    position: fixed;
    bottom: 0;
    background: ${theme.colors.white};
    width: 100vw;
    box-shadow: 1px 1px 8px ${theme.colors.gray_lighter};
    z-index: 11;

    @media (min-width: 1175px) {
        display: none;
    }
`;

const List = styled.ul`
    display: flex;
    list-style-type: none;
    margin: 0;
    justify-content: space-between;
`;

const NavItem = styled.li`
    a.active {
        border-top: 4px solid ${theme.colors.main};
        color: ${theme.colors.main};
        font-family: ${theme.fonts.medium};
    }

    a {
        transition: color 0.23s;
        border-right: 4px solid transparent;
        padding: 15px;
        color: ${theme.colors.gray_dark};
        font-size: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    svg {
        margin: 0;
    }

    &:hover a {
        color: ${theme.colors.main};
    }
`;

export default function MobileNavigation() {
    return (
        <Wrapper>
            <List>
                {navItems.map(link => (
                    <NavItem key={link.title}>
                        <NavLink
                            exact={link.path === '/'}
                            to={link.path}
                            activeClassName="active"
                            isActive={(match, location) => {
                                if (match) {
                                    return true;
                                }
                                // This makes the /ryhmat link active when navigated in different group subsections
                                if (
                                    link.path === '/ryhmat' &&
                                    (location.pathname.includes('/ryhma') ||
                                        location.pathname.includes(
                                            '/kategoria'
                                        ))
                                ) {
                                    return true;
                                }

                                return false;
                            }}
                        >
                            <FontAwesomeIcon icon={link.icon} />
                            {link.title}
                        </NavLink>
                    </NavItem>
                ))}
            </List>
        </Wrapper>
    );
}
